import React from "react";
import "./WebMain.css";
import FBLC from "../../../Assets/Images/Technology/Web/FBLC.svg";
import BusinessImpact from "../../../Assets/Icons/Icon Wrapper.svg";
import { Link } from "react-router-dom";

function WebMain() {
  return (
    <div className="web-main">
      <div className="web-blog">
        <section className="web-start">
          <p>
            Modern web platforms rarely struggle on day one. Problems surface
            later, when traffic grows, features expand, and teams change. At
            Quad Theory Ltd, we choose web technologies for how they behave over
            time, not how impressive they sound upfront.
          </p>
        </section>
        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1"> Microsoft .NET — </span>{" "}
            <span className="span-2">Built For Systems That Need To Last</span>
          </h2>
          <p className="web-section-desc">
            When the platforms become complex and the business logic becomes
            more profound, Microsoft .NET adds stability and structure. It is
            responsible for integrations, security, and scalability without
            being brittle when requirements change.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              Your platform grows without any hidden performance or security
              issues slowing the business down in the future.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">HTML — </span>{" "}
            <span className="span-2">The Silent Backbone Of The Web</span>
          </h2>
          <p className="web-section-desc">
            HTML may be simple but if done correctly, it gives a sense of
            clarity and order to the whole experience. Clean structure helps in
            improving accessibility, consistency and longer-term
            maintainability.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              Well-structured pages load faster, are better ranked and are more
              trustworthy to users.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">CSS — </span>{" "}
            <span className="span-2">Where Structure Meets Experience</span>
          </h2>
          <p className="web-section-desc">
            CSS is about controlling how users actually feel when they navigate
            your website. Layout, spacing, responsiveness and motion all combine
            together to reduce friction and guide attention naturally.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact:</strong>
            <p>
              Better visual clarity means better engagement and makes your brand
              look polished on every device.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">React — </span>{" "}
            <span className="span-2">
              {" "}
              Powering Interfaces That React Instantly
            </span>
          </h2>
          <p className="web-section-desc">
            React makes static pages come to life. It enables users to have a
            pleasing interaction without having to reload the page constantly,
            thereby creating experiences that are fast and intuitive.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              App like interactions engage the user for longer and make complex
              workflows easier to navigate.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">TypeScript — </span>{" "}
            <span className="span-2">JavaScript With Guard Rails</span>
          </h2>
          <p className="web-section-desc">
            As applications grow in scale, the lack of structure is risky.
            TypeScript brings safety: as teams grow, it makes code more
            predictable and easier to reason about.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              Fewer runtime bugs, faster debugging and safer long-term
              development.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">Blazor — </span>{" "}
            <span className="span-2">The Driven C# UI Builder</span>
          </h2>
          <p className="web-section-desc">
            Blazor enables teams to create rich web interfaces with C# and
            eliminates the need to partition logic between languages. This helps
            to keep systems cleaner and easier to maintain.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              Faster development and improved code reuse across the front-end
              and back-end systems.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            <span className="span-1">Python — </span>{" "}
            <span className="span-2">The Comprehensive Problem Solver</span>
          </h2>
          <p className="web-section-desc">
            Python excels behind the scenes, dealing with automation,
            integrations and data-driven workflows with ease. Its simplicity
            enables teams to be fast-moving without compromising reliability.
          </p>
          <div className="business-impact">
            <img src={BusinessImpact} alt="Business Impact Icon" />
            <strong>Business Impact</strong>
            <p>
              Smarter automation, faster integrations, reducing operational
              efforts over time.
            </p>
          </div>
        </section>

        <section className="web-section">
          <h2 className="web-section-title">
            How Our Web Stack Guides Every Decision
          </h2>
          <p className="web-section-desc">
            We do not select our web stack after the design has been completed.
            It influences the way we think from the first conversation. When we
            develop using technologies such as .NET, React, TypeScript, Blazor,
            HTML, and CSS, we are thinking of what comes after the launch.
            Content changes. Features grow. Teams rotate. Our stack is chosen so
            structure stays clear, interfaces remain responsive, and adding new
            ideas doesn't mean rewriting what already works. The result is a web
            platform that grows calmly rather than fighting back.
          </p>
        </section>
      </div>

      <div className="fblc-section d-flex flex-column text-center justify-content-center align-items-center">
        <Link to="/contact-us">
          <button className="impact-btn">Talk To Our Web Team</button>
        </Link>
        <h3>Frontend & Backend Technologies</h3>
        <img src={FBLC} alt="Frontend Backend Chart" className="img-fluid" />
      </div>
    </div>
  );
}

export default WebMain;
